<template>
  <div class="select-major-container">
    <!-- 机构标题 -->
    <div class="institution-header">
      <img src="@/assets/bm/sl_icon_1.png" class="institution-icon" />
      <p class="institution-title">{{ helpInfo.code+'-'+helpInfo.name }}</p>
    </div>

    <!-- 基本信息 -->
    <div class="info-section">
      <!-- <div class="info-item">
        <label class="info-label">学习形式:</label>
        <span class="info-value">{{ helpInfo.studyMode }}</span>
      </div> -->
      <div class="info-item" v-if="helpInfo.principal">
        <label class="info-label">联&nbsp;&nbsp;系&nbsp;&nbsp;人:</label>
        <span class="info-value">{{ helpInfo.principal }}</span>
      </div>
      <div class="info-item" v-if="helpInfo.phone">
        <label class="info-label">联系方式:</label>
        <span class="info-value">{{ helpInfo.phone }}</span>
      </div>
      <div class="info-item" v-if="helpInfo.address">
        <label class="info-label">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址:</label>
        <span class="info-value">{{ helpInfo.address }}</span>
      </div>
    </div>

    <!-- 提示信息 -->
    <div class="notice-section">
      <span class="notice-label">提示:</span>
      <span class="notice-content">报考专升本层次的学员,必须在申请专升本层次毕业证前获得专科层次学历</span>
    </div>

    <!-- 专业表格 -->
    <div class="table-section">
      <el-table
        :data="list"
        border
        stripe
        style="width: 100%;text-align: center;"
        :header-cell-style="{ background: '#E9EFF9', color: '#1A1A1A', fontWeight: 500, textAlign: 'center' }"
      >
        <el-table-column label="序号" min-width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="code" label="专业代码" min-width="120" align="center"></el-table-column>
        <el-table-column prop="name" label="专业名称" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="专业层次" min-width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.edulevel | f('edulevel') }}
          </template>
        </el-table-column>
        <el-table-column prop="fee" label="助学培训费(元/年)" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="专业计划" min-width="100" align="center">
          <template slot-scope="scope">
            <a href="javascript:void(0)" class="link-btn" @click="viewPlan(scope.row)">查看</a>
          </template>
        </el-table-column>
        <el-table-column label="报名" min-width="100" align="center">
          <template slot-scope="scope">
            <a href="javascript:void(0)" class="link-btn" @click="register(scope.row)">报名</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectMajor',
  props: {
    selectedSpecialtyId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      MOCK_PREFIX: process.env.VUE_APP_MOCK_PREFIX || '',
      helpInfo:{},
      list: []
    }
  },
  created() {
    const helpInfo = localStorage.getItem('helpInfo')
    if (helpInfo) {
      this.helpInfo = JSON.parse(helpInfo)
      this.getList()
    }
  },
  methods: {
    getList() {
      this.$http.get(this.MOCK_PREFIX+'/student/pc/getSpecialtyList', {
        helpId: this.helpInfo.id,
        size:999
      }).then(res => {
        this.list = res.records
      })
    },
    viewPlan(row) {
      this.$emit('view-plan', row.id)
    },
    register(row) {
      this.$emit('next-step', row.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.select-major-container {
  width: 100%;
  padding: 20px 0;
  background: #fff;
}

.institution-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 20px;

  .institution-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 18px;
  }

  .institution-title {
    font-size: 20px;
    font-weight: 600;
    color: #1A1A1A;
    margin: 0;
  }
}

.info-section {
  margin-bottom: 20px;

  .info-item {
    display: flex;
    margin-bottom: 10px;
    align-items: flex-start;

    &:last-child {
      margin-bottom: 0;
    }

    .info-label {
      width: 100px;
      font-size: 14px;
      color: #767676;
      font-weight: 500;
      flex-shrink: 0;
    }

    .info-value {
      flex: 1;
      font-size: 14px;
      color: #1A1A1A;
      line-height: 1.5;
    }
  }
}

.notice-section {
  margin-bottom: 15px;

  .notice-label {
    font-size: 16px;
    color: #FF4D4F;
    margin-right: 8px;
  }

  .notice-content {
    font-size: 16px;
    color: #FF4D4F;
    line-height: 1.5;
  }
}

.table-section {
  width: 100%;
  overflow-x: auto;

  .link-btn {
    color: #4084FF;
    text-decoration: none;
    cursor: pointer;
    font-size: 14px;

    &:hover {
      color: #1687DE;
      text-decoration: underline;
    }
  }

  .selected-text {
    color: #67C23A;
    font-size: 14px;
    font-weight: 500;
  }
}

// Element UI 表格样式覆盖
::v-deep .el-table {
  border-radius: 8px;
  overflow: hidden;
  width: 100% !important;
  table-layout: auto;

  .el-table__header-wrapper {
    .el-table__header {
      width: 100% !important;
      th {
        border-color: #DCDFE6;
        padding: 10px 0;
      }
    }
  }

  .el-table__body-wrapper {
    .el-table__body {
      width: 100% !important;
      td {
        border-color: #EBEEF5;
        background-color: #fff;
        padding: 12px 0;
        text-align: center;
      }
    }
  }

  .el-table__row {
    &:hover {
      background-color: #fff;
    }
  }

  &.el-table--striped {
    .el-table__body {
      tr.el-table__row--striped {
        td {
          background-color: #fff;
        }

        &:hover td {
          background-color: #fff;
        }
      }
    }
  }
}
</style>
